import { Toaster } from "@blueprintjs/core";

export const DefaultToaster = Toaster.create({
  position: "bottom-right",
  usePortal: true,
});
